// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","257":"5d5a2349","455":"2281e389","977":"8591a78c"}[chunkId] + ".chunk.js";
};